import React from 'react';

const PageHeader = ({ title, description, actions }) => {
  return (
    <div className="text-center space-y-4 pt-3 mb-6 relative max-w-4xl mx-auto">
      <div className="space-y-1">
        <h1 className="text-2xl font-black text-gray-900 tracking-tighter italic uppercase font-sans">
          {title}
        </h1>
        {description && (
          <p className="text-gray-400 font-medium text-sm max-w-2xl mx-auto leading-relaxed italic font-sans">
            {description}
          </p>
        )}
      </div>

      {actions && (
        <div className="flex items-center justify-center gap-4 mt-8">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
